export default __webpack_public_path__ + "static/Inter-ExtraBold-94346bb8119f7a674b5242647ea1e797.woff2";